import axios, { AxiosError, AxiosRequestConfig, CancelTokenSource } from "axios";
// import { parseAxiosError, showToaster } from "common/constant";
import { BaseService } from "./base.service";
import { IErrorResponse, ISuccessResponse } from "./interfaces/ApiResponse.interface";
import { parseAxiosError, parseAxiosSuccess } from "../common/common";

export class ApiService extends BaseService {

    private cancelTokenSource: CancelTokenSource | undefined;
    private cancelTokenSourceTwo: CancelTokenSource | undefined;

    public async postApi(url: string, reqData: any): Promise<ISuccessResponse | IErrorResponse> {
        try {
            const { data } = await this.httpClient.post(url, reqData);
            // alert(data)
            parseAxiosSuccess(data);
            return data;


        } catch (error) {
            console.error("API Error:", error);
            return parseAxiosError(error as AxiosError);
        }
    }

    public async putApi(url: string, reqData: any): Promise<ISuccessResponse | IErrorResponse> {
        try {
            const { data } = await this.httpClient.put(url, reqData);
            // alert(data)
            parseAxiosSuccess(data);
            return data;


        } catch (error) {
            console.error("API Error:", error);
            return parseAxiosError(error as AxiosError);
        }
    }

    public async postApiSecond(url: string, reqData: any): Promise<ISuccessResponse | IErrorResponse> {
        try {

            const { data } = await this.httpClient.post(url, reqData);
            return data;


        } catch (error) {
            return error as IErrorResponse;
        }
    }

    public async deleteAPi(url: string, reqData?: any): Promise<ISuccessResponse | IErrorResponse> {
        try {

            const { data } = await this.httpClient.delete(url, reqData);
            // alert(data)
            parseAxiosSuccess(data);
            return data;


        } catch (error) {
            return parseAxiosError(error as AxiosError);
        }
    }

    public async getApi(url: string, reqData?: any, returnError: boolean = false): Promise<ISuccessResponse | IErrorResponse> {
        try {
            this.cancelPreviousRequest();

            const cancelToken = axios.CancelToken.source();
            this.cancelTokenSource = cancelToken;

            const config: AxiosRequestConfig = {
                params: reqData,
                cancelToken: cancelToken.token,
            };

            const { data } = await this.httpClient.get(url, config);

            return data;

        } catch (error) {
            return parseAxiosError(error as AxiosError);
        }
    }

    public async getApiSecond(url: string, reqData?: any): Promise<ISuccessResponse | IErrorResponse> {
        try {
            this.cancelPreviousRequestSecond();

            const cancelToken = axios.CancelToken.source();
            this.cancelTokenSourceTwo = cancelToken;

            const config: AxiosRequestConfig = {
                params: reqData,
                cancelToken: cancelToken.token,
            };

            const { data } = await this.httpClient.get(url, config);

            return data;

        } catch (error) {
            return parseAxiosError(error as AxiosError);
        }
    }

    public async getApiWithHeaders(url: string, headers?: any, params?: any): Promise<ISuccessResponse | IErrorResponse> {
        try {
            this.cancelPreviousRequest();

            const cancelToken = axios.CancelToken.source();
            this.cancelTokenSource = cancelToken;

            const config: AxiosRequestConfig = {
                headers: headers,
                params: params,
                cancelToken: cancelToken.token,
            };

            const { data } = await this.httpClient.get(url, config);
            parseAxiosSuccess(data);
            return data;

        } catch (error) {
            return parseAxiosError(error as AxiosError);
        }
    }

    public async getApiWithHeadersNoToast(url: string, headers?: any, params?: any): Promise<ISuccessResponse | IErrorResponse> {
        try {
            this.cancelPreviousRequest();

            const cancelToken = axios.CancelToken.source();
            this.cancelTokenSource = cancelToken;

            const config: AxiosRequestConfig = {
                headers: headers,
                params: params,
                cancelToken: cancelToken.token,
            };

            const { data } = await this.httpClient.get(url, config);
            // Don't call parseAxiosSuccess to avoid toaster notifications
            return data;

        } catch (error) {
            return parseAxiosError(error as AxiosError);
        }
    }

    private cancelPreviousRequest() {
        if (this.cancelTokenSource) {
            this.cancelTokenSource.cancel('Request canceled due to new request');
        }
    }

    private cancelPreviousRequestSecond() {
        if (this.cancelTokenSourceTwo) {
            this.cancelTokenSourceTwo.cancel('Request canceled due to new request Second');
        }
    }

}